<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1 class="mb-10">{{ dialogSettings.title }}</h1>
        <MessageTemplateForm ref="messageTemplateForm" />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton
        :loading="isAddingOrganisationMessageTemplate"
        @click.native="createTemplate"
      >
        Create Message Template
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-message-templates";
import { copyState } from "@/utils/helpers";
import { BASE_PAGINATION_REQUEST_PARAMS } from "@/constants/pagination";
import {
  ADD_ORGANISATION_MESSAGE_TEMPLATE,
  FETCH_ORGANISATION_MESSAGE_TEMPLATES
} from "@/store/modules/organisations/organisation-message-templates/actions";
import MessageTemplateForm from "@/views/settings/components/message-templates/components/MessageTemplateForm";
import { getConvertedEmailBody } from "@/utils/conversations";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_MESSAGE_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    MessageTemplateForm
  },
  computed: {
    ...mapState(copyState(["isAddingOrganisationMessageTemplate"])),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "New Message Template"
      };
    }
  },
  methods: {
    ...mapActions({
      addMessageTemplate: ADD_ORGANISATION_MESSAGE_TEMPLATE,
      fetchMessageTemplates: FETCH_ORGANISATION_MESSAGE_TEMPLATES
    }),
    async createTemplate() {
      const isFormValid = await this.$refs.messageTemplateForm.validateForm();
      if (isFormValid) {
        const { messageTemplateData } = this.$refs.messageTemplateForm;
        const { data: newMessageTemplate } = await this.addMessageTemplate({
          ...messageTemplateData,
          body: getConvertedEmailBody(messageTemplateData.body)
        });
        await this.$refs.messageTemplateForm.uploadNewFiles(
          newMessageTemplate.id
        );
        this.close();
      }
    },
    close() {
      this.fetchMessageTemplates(BASE_PAGINATION_REQUEST_PARAMS);
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
